import { useSelector } from 'react-redux';
import styles from '../Dashboard.module.scss';
import { isAppUrl } from 'shared/utils';
import { getOperationalData } from 'shared/store/selectors/workspace.selector';
import analyticsService from 'src/helpers/analytics.service';
import { EVENTS } from 'shared/constants';

export function DashboardBanner() {
  const { dashboardBanner } = useSelector(getOperationalData);
  const { webImage = '', imageLink = '' } = dashboardBanner || {};

  const handleClick = () => {
    analyticsService.track(EVENTS.HOME_PAGE.BANNER_CLICK, {
      url: imageLink,
    });
  };

  if (!webImage) {
    return null;
  }

  return (
    <a
      href={imageLink || undefined}
      rel="noreferrer"
      className={styles.banner}
      target={isAppUrl(imageLink) ? '_self' : '_blank'}
      onClick={handleClick}
    >
      <img src={webImage} alt="banner" />
    </a>
  );
}
